import { Component, Input, OnInit, OnDestroy } from '@angular/core'
import { PortalGlobals } from '../../../../app/portalglobals'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentPageContent } from '../../models/enrollment-page-content-model'
import { CurrentUser } from '../../../common/models/current-user'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { EnrollmentSettingModel } from '../../models/EnrollmentSettingModel'
import { Router } from '@angular/router'
import { TrainingCertificatesGateway } from '../../../training/gateways/training-certificates-gateway'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import { CommonGateway } from '../../../common/gateways/common-gateway'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
import { Title } from '@angular/platform-browser';

@Component({
    templateUrl: 'enrollment-page.component.html'
})
export class EnrollmentPageComponent implements OnInit, OnDestroy {
    enrollmentPageContent: string
    displayEnrollmentDirection: string
    isEnrollmentPageContent: boolean = false
    uxMessageLabel: boolean = false
    isDisplayEnrollmetDirection: boolean = false
    noteMsg: string
    trainingMsg: boolean = false
    backgroundMsg: boolean = false
    trainingFailedMsg: boolean = false
    trainingPassed: boolean = false
    planYear: string
    ClickHereVisible: boolean
    ICNAME: string
    LinceseMsg: boolean = false
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    currentUser: CurrentUser = {} as CurrentUser
    insCo: string
    insuranceCompany: string
    SkipRTSCheck: boolean = false
    baseTitle: string

    constructor(
        private gateway: EnrollmentGateway,
        private portalGlobal: PortalGlobals,
        private route: Router,
        private trainingCertificatesGateway: TrainingCertificatesGateway,
        private _currentUserGateway: CurrentUserGateway,
        private userdataservice: UserDataService,
        private commonGateway: CommonGateway,
        private routers: Router,
        private titleService:Title
    ) {}

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')

        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle( this.baseTitle + ' - Enrollment')

        if (User !== undefined) {
            this.currentUser = JSON.parse(User!)
            this.insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()

            this.setPageData(User)
        } else {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this.portalGlobal.currentUser = user
                    this.insCo = this.portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
                    localStorage.setItem('UserSessionContext', JSON.stringify(this.portalGlobal.currentUser))
                    if (this.portalGlobal.selectedPlanYear === 0) {
                        this.userdataservice.currentYear.subscribe((data) => {
                            this.portalGlobal.selectedPlanYear = data
                            this.setPageData(user)
                        })
                    } else {
                        this.setPageData(user)
                    }
                }
            })
        }
        this.currentUser = JSON.parse(User!)
    }

    setPageData(User: any) {
        this.currentUser = JSON.parse(User!)
        if (this.portalGlobal !== undefined && this.portalGlobal.currentUser === undefined) {
            this.portalGlobal.currentUser = this.currentUser
        }
        this.planYear = this.portalGlobal.selectedPlanYear.toString()
        this.ICNAME = this.currentUser.insuranceCompanyName
        this.trainingFailedMsg = false
        this.uxMessageLabel = false
        this.setOrgname()

        if (localStorage.getItem('GoodStandingParams') != null) {
            this.goodStandingValues = JSON.parse(localStorage.getItem('GoodStandingParams')!)

            if (this.currentUser !== undefined && this.currentUser !== null) {
                if (
                    this.currentUser.AgreementVersionNumber !== null &&
                    this.currentUser.AgreementVersionNumber.trim() === '40' &&
                    (this.currentUser.IsAgent || this.currentUser.IsDataEntrySpecialist)
                ) {
                    this.SkipRTSCheck = true
                }
            }

            if (!this.SkipRTSCheck) {
                //if (this.currentUser !== undefined && this.currentUser !== null && !this.currentUser.IsEnoller && !this.currentUser.isOrganizationalAdmin && !this.currentUser.isOrganizationalManager && !this.currentUser.IsAdminOrAgent &&
                if (
                    this.currentUser !== undefined &&
                    this.currentUser !== null &&
                    !this.currentUser.IsAdminOrAgent &&
                    this.currentUser.orgName !== undefined &&
                    this.currentUser.orgName !== null &&
                    this.currentUser.orgName.toUpperCase() !== 'SSIDE' &&
                    !this.currentUser.isOrganizationalAdmin &&
                    !this.currentUser.isOrganizationalManager
                ) {
                    if (!this.currentUser.IsDataEntryGroupSpecialist) {
                        if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                            //&& !this.currentUser.isOrganizationalAdmin && !this.currentUser.isOrganizationalManager)
                            this.uxMessageLabel = true
                            this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                            this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                            this.LinceseMsg = !this.goodStandingValues.LicenseStatus

                            if (this.goodStandingValues.CurriculumStatusDesc !== undefined && this.goodStandingValues.CurriculumStatusDesc !== null) {
                                if (this.goodStandingValues.CurriculumStatusDesc.toLowerCase() === 'failed') {
                                    this.trainingFailedMsg = true
                                }
                            }
                            return
                        }
                    } else {
                        if (this.goodStandingValues !== undefined && this.goodStandingValues != null) {
                            if (!this.goodStandingValues.CurriculumStatus) {
                                this.uxMessageLabel = true
                                this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                            }
                            if (!this.goodStandingValues.BackgroundCheckStatus) {
                                this.uxMessageLabel = true
                                this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                            }
                            if (this.currentUser.IsAdminOrAgent) {
                                if (!this.goodStandingValues.LicenseStatus) {
                                    this.uxMessageLabel = true
                                    this.LinceseMsg = !this.goodStandingValues.LicenseStatus
                                }
                            }
                            if (this.goodStandingValues.CurriculumStatusDesc !== undefined && this.goodStandingValues.CurriculumStatusDesc !== null) {
                                if (this.goodStandingValues.CurriculumStatusDesc.toLowerCase() === 'failed') {
                                    this.uxMessageLabel = true
                                    this.trainingFailedMsg = true
                                }
                            }
                        }
                    }
                }
            }

            if (this.uxMessageLabel === false) {
                this.gateway.getEnrollmentSetting(this.planYear, this.currentUser).subscribe((model: EnrollmentSettingModel) => {
                    let response = model
                    if (response !== undefined) {
                        this.enrollmentPageContent = response.enrollmentPageContent
                        this.isEnrollmentPageContent = response.isEnrollmentPageContent
                        this.ClickHereVisible = response.ClickHereVisible
                    }
                })
            }
        } else {
            this.setGoodStandingStatus()
        }
    }

    setGoodStandingStatus() {
        if (this.portalGlobal.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this.portalGlobal.currentUser = user
                    if (this.portalGlobal.selectedPlanYear === 0) {
                        this.userdataservice.currentYear.subscribe((data) => {
                            this.portalGlobal.selectedPlanYear = data
                            this.setGoodStanding()
                        })
                    } else {
                        this.setGoodStanding()
                    }
                }
            })
        } else {
            this.setGoodStanding()
        }
    }

    setGoodStanding() {
        this.commonGateway.getGoodStandingDetails(this.portalGlobal.currentUser.userProfileId, String(this.portalGlobal.selectedPlanYear)).subscribe(
            (model: GoodStandingModel) => {
                this.goodStandingValues = model
                if (model.GoodStandingStatus !== undefined && model.GoodStandingStatus !== null && model.GoodStandingStatus) {
                    sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                    localStorage.setItem('GoodStandingParams', JSON.stringify(model))
                } else {
                    sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                    localStorage.setItem('GoodStandingParams', JSON.stringify(model))
                }

                if (this.currentUser !== undefined && this.currentUser !== null) {
                    if (
                        this.currentUser.AgreementVersionNumber !== null &&
                        this.currentUser.AgreementVersionNumber.trim() === '40' &&
                        this.currentUser.IsAgent
                    ) {
                        this.SkipRTSCheck = true
                    }
                }

                //Skip RTS check fro Agent agreement=40
                if (!this.SkipRTSCheck) {
                    //if (this.currentUser !== undefined && this.currentUser !== null && !this.currentUser.IsEnoller && !this.currentUser.isOrganizationalAdmin && !this.currentUser.isOrganizationalManager && !this.currentUser.IsAdminOrAgent &&
                    if (
                        this.currentUser !== undefined &&
                        this.currentUser !== null &&
                        !this.currentUser.IsAdminOrAgent &&
                        this.currentUser.orgName !== undefined &&
                        this.currentUser.orgName !== null &&
                        this.currentUser.orgName.toUpperCase() !== 'SSIDE' &&
                        !this.currentUser.isOrganizationalAdmin &&
                        !this.currentUser.isOrganizationalManager
                    ) {
                        if (!this.currentUser.IsDataEntryGroupSpecialist) {
                            if (
                                this.goodStandingValues !== undefined &&
                                this.goodStandingValues != null &&
                                !this.goodStandingValues.GoodStandingStatus
                            ) {
                                /* && !this.currentUser.isOrganizationalAdmin && !this.currentUser.isOrganizationalManager)*/ this.uxMessageLabel =
                                    true
                                this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                                this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                                this.LinceseMsg = !this.goodStandingValues.LicenseStatus

                                if (
                                    this.goodStandingValues.CurriculumStatusDesc !== undefined &&
                                    this.goodStandingValues.CurriculumStatusDesc !== null
                                ) {
                                    if (this.goodStandingValues.CurriculumStatusDesc.toLowerCase() === 'failed') {
                                        this.trainingFailedMsg = true
                                    }
                                }
                                return
                            }
                        } else {
                            if (this.goodStandingValues !== undefined && this.goodStandingValues != null) {
                                if (!this.goodStandingValues.CurriculumStatus) {
                                    this.uxMessageLabel = true
                                    this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                                }
                                if (!this.goodStandingValues.BackgroundCheckStatus) {
                                    this.uxMessageLabel = true
                                    this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                                }
                                if (this.currentUser.IsAdminOrAgent) {
                                    if (!this.goodStandingValues.LicenseStatus) {
                                        this.uxMessageLabel = true
                                        this.LinceseMsg = !this.goodStandingValues.LicenseStatus
                                    }
                                }
                                if (
                                    this.goodStandingValues.CurriculumStatusDesc !== undefined &&
                                    this.goodStandingValues.CurriculumStatusDesc !== null
                                ) {
                                    if (this.goodStandingValues.CurriculumStatusDesc.toLowerCase() === 'failed') {
                                        this.uxMessageLabel = true
                                        this.trainingFailedMsg = true
                                    }
                                }
                            }
                        }
                    }
                }
            },
            (error) => {
                console.log(error)
            }
        )
    }

    GetTrainingURL() {
        /*
        this.trainingCertificatesGateway.LogintoCourseGuide(this.portalGlobal.currentUser.userProfileName,
            this.portalGlobal.selectedPlanYear).subscribe
            ((data) => {
                window.open(data, '_blank')
            })
        */
        const insCo = this.portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/training/trainingDetail'])
    }
    GetEnrollmentInfoURL() {
        this.route.navigate(['/' + this.insCo + '/enrollment/enrollmentInfo'])
        //[routerLink] = "['../enrollmentInfo']"
    }

    private setOrgname() {
        if (this.portalGlobal.selectedPlanYear === 0 || this.portalGlobal.selectedPlanYear === undefined) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this.portalGlobal.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
            }
        }
        if (Number(this.portalGlobal.selectedPlanYear) === this.portalGlobal.CurrentYear) {
            this.insuranceCompany = this.ICNAME
        } else {
            if (this.currentUser.insuranceCompanyName !== this.portalGlobal.insuranceCompanyNameNEJE)
                this.insuranceCompany = this.portalGlobal.insCompanyNameAetna
            else this.insuranceCompany = this.ICNAME
        }
    }
}
